<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="mapCard"
  >
    <form
      autocomplete="off"
      class="m-edition-map-card"
      name="update-proyecto-form"
      @submit.prevent="updateProyecto"
    >

      <div class="m-edition-map-card-content">
        <!-- estado, categoría y descripcion del proyecto -->
        <div class="m-edition-map-card-data">
          <h3 class="margin-top-zero">
            {{ $t('mEditionMapCard.inputs.publicado.label') }}
          </h3>
          <p class="margin-top-zero">
            <AtomTogglePrimary
              v-model="proyecto.publicado"
              name="publicado"
              slider-class="a-toggle-slider-maps-primary"
              switch-class="a-toggle-switch-left-primary"
              :text="proyecto.publicado === 1
                ? $t('mEditionMapCard.inputs.publicado.textTrue')
                : $t('mEditionMapCard.inputs.publicado.textFalse') "
              type="checkbox"
            />
          </p>

          <h3 class="margin-top-xxlarge">
            {{ $t('mEditionMapCard.inputs.descripcion.label') }}
          </h3>
          <p class="margin-top-zero">
            <AtomTextAreaPrimary
              v-model="proyecto.descripcion"
              :inputError="$v.proyecto.descripcion.$error"
              :message="$t('mEditionMapCard.inputs.descripcion.message')"
              :messageError="messageErrorDescripcion"
              name="descripcion"
              reference="descripcion"
              rows="3"
              wrapper-class="a-input-wrapper-column margin-bottom-zero margin-top-zero"
              @blur="$v.proyecto.descripcion.$touch()"
            />
          </p>

          <h3 class="margin-bottom-small margin-top-xxlarge">
            {{ $t('mEditionMapCard.inputs.activacion.label') }}
          </h3>
          <div class="margin-bottom-medium margin-top-zero">
            <div class="display-flex-row-center">
              <AtomRadioButtonPrimary
                v-model.number="activacion"
                :radio-button-primary="radioButtonPrimary"
                :value="1"
                :text="$t('mEditionMapCard.inputs.activacion.labelOne')"
                :tooltip="$t('mEditionMapCard.inputs.activacion.tooltipOne')"
              />
              <AtomRadioButtonPrimary
                v-model.number="activacion"
                :radio-button-primary="radioButtonPrimary"
                :value="0"
                :text="$t('mEditionMapCard.inputs.activacion.labelZero')"
                :tooltip="$t('mEditionMapCard.inputs.activacion.tooltipZero')"
              />
            </div>

            <transition name="a-transtion-slide">
              <div
                v-show="activacion == 1"
                class="display-flex-column margin-top-large"
              >
                <AtomDatePicker
                  v-model="proyecto.fecha_inicio"
                  :disabled-dates="disabledDatesStart"
                  inputClass="width-250-px"
                  :inputError="$v.proyecto.fecha_inicio.$error"
                  :label="$t('mEditionMapCard.inputs.fecha_inicio.label')"
                  :message="$t('mEditionMapCard.inputs.fecha_inicio.message')"
                  :messageError="messageErrorFechaInicio"
                  name="fecha_inicio"
                  :placeholder="$t('mEditionMapCard.inputs.fecha_inicio.placeholder')"
                  wrapperClass="margin-zero width-250-px"
                  @blur="$v.proyecto.fecha_inicio.$touch()"
                />

                <AtomDatePicker
                  v-model="proyecto.fecha_fin"
                  :disabled-dates="disabledDatesEnd"
                  inputClass="width-250-px"
                  :label="$t('mEditionMapCard.inputs.fecha_fin.label')"
                  :message="$t('mEditionMapCard.inputs.fecha_fin.message')"
                  name="fecha_fin"
                  :placeholder="$t('mEditionMapCard.inputs.fecha_fin.placeholder')"
                  wrapperClass="width-250-px"
                />
              </div>
            </transition>

            <p class="margin-top-xlarge">
              <AtomButtonPrimary
                class="margin-right-small"
                :button-primary="buttonPrimary"
              />
              <AtomButtonSecondary
                :button-secondary="buttonSecondary.reset"
                @resetEditor="resetEditor"/>
            </p>
          </div>

        </div>

        <!-- tarjeta del proyecto -->
        <div class="m-edition-map-card-design">
          <MoleculeFeedSectionContentCard
            :is="moleculeCardEditionDesign"
            :element="proyecto"
            :element-categorias="elementCategorias"
            :show-metadata-validation-error="showMetadataValidationError"
            @changeElementCard="changeElementCard"
            @changeElementNombre="changeElementNombre"
            @getValidationError="getValidationError"
            @getReference="getReference"
          />
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionMapCard',

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      activacion: 0,

      buttonPrimary: {
        action: this.$t('mEditionMapCard.buttonPrimary'),
        class: 'a-button-maps-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: 'far fa-times',
          method: 'resetEditor',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'button'
        }
      },

      cardType: 2,

      disabledDatesEnd: {
        to: ''
      },

      disabledDatesStart: {
        to: ''
      },

      moleculeCardEditionDesign: () => import(`@/components/molecules/MoleculeFeedSectionContentCardEditionDesign${this.cardType}`),

      proyecto: {
        categoria: 1,
        descripcion: '',
        fecha_fin: null,
        fecha_inicio: null,
        imagen: '',
        publicado: 0,
        titulo: ''
      },

      primeraVez: true,
      proyectoInicial: {},

      radioButtonPrimary: {
        labelClass: 'a-radiobutton-maps-primary margin-top-zero',
        name: 'activacion'
      },

      showMetadataValidationError: false,
      showLoadingState: false,

      validationError: {
        card: false,
        name: false
      }
    }
  },

  validations: {
    proyecto: {
      descripcion: {
        maxLength: maxLength(120),
        minLength: minLength(10),
        required
      },

      fecha_inicio: {
        required: requiredIf(function () {
          return parseInt(this.activacion) === 1
        })
      }
    }
  },

  computed: {
    messageErrorDescripcion () {
      return this.$validation.getValidationMessage('mEditionMapCard', this.$v.proyecto.descripcion, 'descripcion')
    },

    messageErrorFechaInicio () {
      return this.$validation.getValidationMessage('mEditionMapCard', this.$v.proyecto.fecha_inicio, 'fecha_inicio')
    }
  },

  watch: {
    activacion () {
      if (parseInt(this.activacion) === 0) {
        this.proyecto.fecha_fin = null
        this.proyecto.fecha_inicio = null
      }
    },

    // TODO: colocar alerta que pida guardar cambios antes de abandonar página en caso de que proyectoInicial y proyecto sean diferentes
    element () {
      this.setProyecto()
    },

    'proyecto': {
      deep: true,
      handler (newValue, oldValue) {
        if (!this.primeraVez && JSON.stringify(newValue) !== JSON.stringify(this.proyectoInicial)) {
          this.$store.commit('setExitEdition', true)
        }

        // Lógica específica para el campo 'fecha_inicio'
        if (this.$moment(this.proyecto.fecha_inicio).isAfter(this.proyecto.fecha_fin) || this.proyecto.fecha_inicio === null || this.proyecto.fecha_inicio === '') {
          this.proyecto.fecha_fin = null
        }

        this.disabledDatesEnd = {
          to: this.proyecto.fecha_inicio
        }
      }
    },

    '$store.getters.getExitEditionRoute' () {
      if (this.$store.getters.getExitEditionRoute.edition && !this.primeraVez) {
        this.$modal.showModal('MoleculeEditionExitModal', '')
      }
    }
  },

  created () {
    this.activacion = this.element.fecha_inicio ? 1 : 0
    this.proyectoInicial = {
      categoria: 1,
      descripcion: this.element.descripcion,
      imagen: this.element.imagen ? this.element.imagen : require('@/assets/img/ds2.png'),
      fecha_fin: this.element.fecha_finalizacion ? this.$moment.parseZone(this.element.fecha_finalizacion).format('YYYY-MM-DD') : null,
      fecha_inicio: this.element.fecha_inicio ? this.$moment.parseZone(this.element.fecha_inicio).format('YYYY-MM-DD') : null,
      publicado: +this.element.publicado,
      titulo: this.element.titulo
    }
    setTimeout(() => {
      this.primeraVez = false
    }, 100)
  },

  mounted () {
    this.disabledDatesStart = {
      to: this.$moment().subtract(1, 'days').format('YYYY-MM-DD')
    }

    this.setProyecto()
  },

  methods: {
    changeElementCard (card) {
      this.proyecto.imagen = card.metadata.imagen
    },

    changeElementNombre (nombre) {
      this.proyecto.titulo = nombre
    },

    getReference (name, ref) {
      this.$refs[name] = ref
    },

    getValidationError (vKey, vError) {
      this.validationError[vKey] = vError
    },

    resetEditor () {
      if (this.proyectoInicial.fecha_fin == null && this.proyectoInicial.fecha_inicio == null) {
        this.activacion = 0
      } else {
        this.activacion = 1
      }
      this.proyecto = JSON.parse(JSON.stringify(this.proyectoInicial))
      this.$refs.imagen.src = JSON.parse(JSON.stringify(this.proyectoInicial.imagen))
      this.$store.commit('setExitEdition', false)
    },

    setProyecto () {
      this.proyecto = {
        categoria: 1,
        descripcion: this.element.descripcion,
        imagen: this.element.imagen,
        fecha_fin: this.element.fecha_finalizacion ? this.$moment.parseZone(this.element.fecha_finalizacion).format('YYYY-MM-DD') : null,
        fecha_inicio: this.element.fecha_inicio ? this.$moment.parseZone(this.element.fecha_inicio).format('YYYY-MM-DD') : null,
        publicado: +this.element.publicado,
        titulo: this.element.titulo
      }
    },

    updateProyecto () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      this.showMetadataValidationError = true

      if (this.proyecto.fecha_fin === null || this.proyecto.fecha_fin === '') {
        delete this.proyecto.fecha_fin
      }

      if (parseInt(this.activacion) === 0 && (this.proyecto.fecha_inicio === null || this.proyecto.fecha_inicio === '')) {
        delete this.proyecto.fecha_inicio
      }

      if (Object.values(this.validationError).find(verror => verror) === undefined &&
        !this.buttonPrimary.sending &&
        !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.update('proyecto', 'updateProyecto', this.proyecto, [this.$route.params.id])
          .then(response => {
            this.$modal.updateData('readElement')
            this.$alerts.pushAlert('mEditionMapCard', 'updateProyecto', 'success')
            this.$store.commit('setExitEdition', false)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionMapCard', 'updateProyecto', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      } else {
        this.$nextTick(() => {
          switch (true) {
            case this.validationError.name === true:
              this.$refs.nombre.focus()
              break
            case this.validationError.card === true:
              this.$refs.imagen.scrollIntoView()
              break
          }
        })
      }
    }
  }
}
</script>
